var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { ButtonToggleItem } from './ButtonToggleItem';
export const ButtonToggle = React.forwardRef(function (_a, ref) {
    var { color = 'primary', primary, negative, className, disabled, el: ButtonToggleElement = 'div', clearable, options = [], large, small, xsmall, name, size = 'medium', value, onChange } = _a, props = __rest(_a, ["color", "primary", "negative", "className", "disabled", "el", "clearable", "options", "large", "small", "xsmall", "name", "size", "value", "onChange"]);
    const [selected, setSelected] = React.useState(value);
    React.useEffect(() => {
        setSelected(value);
    }, [value]);
    const handleClick = (select) => {
        const realSelected = select !== selected || !clearable ? select : undefined;
        if (onChange)
            onChange(realSelected);
        setSelected(realSelected);
    };
    const copyOptions = (options) => {
        const copiedOptions = options.map((option) => {
            return {
                text: option.text,
                value: option.value,
                onClick: option.onClick,
                disabled: option.disabled,
                selected: option.selected,
                hidden: option.hidden,
                icon: option.icon,
                iconName: option.iconName,
            };
        });
        return copiedOptions;
    };
    const getOnlySelected = (options) => {
        let isSelected = false;
        const onlyOneSelectedOptions = options.map((option) => {
            if (option.selected && !isSelected) {
                isSelected = true;
            }
            else {
                option.selected = false;
            }
            return option;
        });
        return onlyOneSelectedOptions;
    };
    const getNormalized = (options) => {
        const realOptions = options.map((option) => {
            if (disabled)
                option.disabled = disabled;
            if (option.text === undefined)
                option.text = null;
            if (selected !== undefined || clearable)
                option.selected = selected === option.value;
            return option;
        });
        return realOptions;
    };
    const getRealColor = () => {
        let realColor = color;
        if (primary)
            realColor = 'primary';
        if (negative)
            realColor = 'negative';
        return realColor;
    };
    const getButtonToggleItemProps = (options) => {
        let realSize = size;
        // Override string props with boolean values
        if (xsmall)
            realSize = 'xsmall';
        if (small)
            realSize = 'small';
        if (large)
            realSize = 'large';
        const buttonToggleItemProps = options.map((option) => {
            return {
                name,
                text: option.text,
                value: option.value,
                disabled: option.disabled,
                selected: option.selected,
                color: getRealColor(),
                size: realSize,
                hidden: option.hidden,
                onClick: (value) => {
                    if (option.onClick)
                        option.onClick(value);
                    handleClick(value);
                },
                icon: option.icon,
                iconName: option.iconName,
            };
        });
        return buttonToggleItemProps;
    };
    const copiedOptions = copyOptions(options);
    const onlySelectedOptions = getOnlySelected(copiedOptions);
    const normalizedOptions = getNormalized(onlySelectedOptions);
    const buttonToggleItemProps = getButtonToggleItemProps(normalizedOptions);
    const contents = buttonToggleItemProps.map((buttonProp, index) => {
        return React.createElement(ButtonToggleItem, Object.assign({ key: index }, buttonProp));
    });
    const realColor = getRealColor();
    const ButtonToggleClasses = classnames('ButtonToggle', className, {
        'ButtonToggle--disabled': disabled,
        [`ButtonToggle--${realColor}`]: realColor,
    });
    return (React.createElement(ButtonToggleElement, Object.assign({ className: ButtonToggleClasses, ref: ref, "data-anvil-component": "ButtonToggle" }, props), contents));
});
//# sourceMappingURL=ButtonToggle.js.map